import { render, staticRenderFns } from "./TebligatMasrafForm.vue?vue&type=template&id=c96a2212"
import script from "./TebligatMasrafForm.vue?vue&type=script&lang=ts"
export * from "./TebligatMasrafForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports